// Mother's Day landing page: smooth scroll + clean URL hash
(function () {
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#shopify-section-template"]');
    if (!a) return;
    var href = a.getAttribute('href');
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '',
        window.location.pathname + window.location.search);
    }
  });
})();
